import { createFileRoute } from "@tanstack/react-router";
import { CandidaturePage } from "@/views/public/candidature/CandidaturePage.tsx";

export const Route = createFileRoute("/_public/candidature/")({
  component: CandidaturePage,
});
